import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  cerrarAlerta,
  mostraAlertaError,
  mostraAlertaOk,
  mostraAlertaPersonalizada,
  mostrarAlertaLoading
} from "../../../componentes/alerts/sweetAlert";
import { AxiosPublico } from "../../../componentes/axios/Axios";
import Card from "../../../componentes/contenedores/Card";
import GestionUbicacion from "../../../componentes/googlemap/GestionUbicacion";
import VerUbicacion from "../../../componentes/googlemap/VerUbicacion";
import ModalBootstrap from "../../../componentes/modal/ModalBootstrap";
import Page from "../../../componentes/plantilla/Page";
import { ImagenCliente, PedidosGuardar } from "../../../configuracion/apiUrls";
import { DireccionConfig } from "../../../configuracion/Empresa";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";
import ModalProductosWizard from "./nuevo/ModalProducto";
import DetalleProductoPedido from "../../../componentes/pedidos/DetalleProductoPedido";
import { formatoMoneda } from "../../../configuracion/validaciones";
import CardPerfilCliente from "../../../componentes/clientes/CardPerfilCliente";
import { ErroresPeticion } from "../../../componentes/axios/ErroresPeticion";

const calcularPrecioFinalConTodo = (datosProducto, cantidad, selectedLote = null) => {
  let precioFinal;
  let esMayoreoAplicado = false;

  if (selectedLote && selectedLote.precio) {
    precioFinal = parseFloat(selectedLote.precio);
  } else {
    precioFinal = parseFloat(datosProducto.precio) || 0;
  }

  let precioOriginalProducto = precioFinal;

  if (selectedLote && selectedLote.loteprecios && selectedLote.loteprecios.length > 0) {
    const nivelesMayoreoOrdenadosLote = [...selectedLote.loteprecios].sort((a, b) => b.cantidad - a.cantidad);
    for (const nivel of nivelesMayoreoOrdenadosLote) {
      if (cantidad >= nivel.cantidad) {
        precioFinal = parseFloat(nivel.precio) || 0;
        esMayoreoAplicado = true;
        break;
      }
    }
  }
  else if (!selectedLote && datosProducto.productoprecios && datosProducto.productoprecios.length > 0) {
    const nivelesMayoreoOrdenados = [...datosProducto.productoprecios].sort((a, b) => b.cantidad - a.cantidad);
    for (const nivel of nivelesMayoreoOrdenados) {
      if (cantidad >= nivel.cantidad) {
        precioFinal = parseFloat(nivel.precio) || 0;
        esMayoreoAplicado = true;
        break;
      }
    }
  }

  return {
    price: precioFinal.toFixed(2),
    precioOriginalProducto: precioOriginalProducto.toFixed(2),
    esMayoreoAplicado,
  };
};

const HomePedidos = () => {
  const { carritoPedidos, vaciarCarritoPedidos, setCarritoPedidos, usuario, estacion } = useContextUsuario();
  const { listaProductos, listaClientes, listaTiposProductos, ActualizarProductos } = useContextEmpleado();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState({});
  const [modalClienteOpen, setModalClienteOpen] = useState(false);
  const clientes = listaClientes || [];
  const [clienteSearchTerm, setClienteSearchTerm] = useState("");
  const fechaActual = moment().format("dddd, DD [de] MMMM [de] YYYY");
  const [notaGeneral, setNotaGeneral] = useState("");
  const [requiereEnvio, setRequiereEnvio] = useState(false);
  const [mostrarBotonEnvio, setMostrarBotonEnvio] = useState(false);
  const [nuevaDireccion, setNuevaDireccion] = useState({
    direccion: DireccionConfig.direccion,
    longitud: DireccionConfig.longitud,
    latitud: DireccionConfig.latitud,
  });
  const [seleccionarDireccion, setSeleccionarDireccion] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formularioClientes, setFormularioClientes] = useState({
    direcciones: [],
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (seleccionarDireccion) {
      setIsModalOpen(false);
      if (formularioClientes.direcciones.length >= 1) {
        mostraAlertaError("Solo puedes agregar una dirección por pedido.");
      } else {
        setFormularioClientes((prevState) => ({
          ...prevState,
          direcciones: [...prevState.direcciones, nuevaDireccion],
        }));
      }
      setSeleccionarDireccion(false);
    }
  }, [seleccionarDireccion, nuevaDireccion, formularioClientes.direcciones]);

  const datos = {
    titulo: {
      titulo: "Nuevo pedido",
      url: "/app/admin/pedidos/nuevo",
      tituloUrl: "pedidos",
      nombreUrl: "Inicio pedidos",
    },
  };

  const agregarAlCarrito = (productoSeleccionado) => {
    setCarritoPedidos((prev) => {
      const productoExistente = prev.find((item) => item.id === productoSeleccionado.id &&
        item.loteSeleccionado?.id === productoSeleccionado.loteSeleccionado?.id &&
        item.loteInventarioSeleccionado?.id === productoSeleccionado.loteInventarioSeleccionado?.id
      );

      if (productoExistente) {
        const nuevaCantidad = productoExistente.cantidad + productoSeleccionado.cantidad;
        const productoCompleto = listaProductos.find(p => p.id === productoSeleccionado.id);
        const detallesPrecio = calcularPrecioFinalConTodo(
          productoCompleto,
          nuevaCantidad,
          productoSeleccionado.loteSeleccionado
        );
        return prev.map((item) =>
          (item.id === productoSeleccionado.id &&
            item.loteSeleccionado?.id === productoSeleccionado.loteSeleccionado?.id &&
            item.loteInventarioSeleccionado?.id === productoSeleccionado.loteInventarioSeleccionado?.id)
            ? { ...item, cantidad: nuevaCantidad, ...detallesPrecio }
            : item
        );
      } else {
        return [...prev, { ...productoSeleccionado }];
      }
    });
  };

  const limpiarDatos = () => {
    setFormularioClientes({
      direcciones: [{ direccion: "", longitud: null, latitud: null }],
    });
    setNotaGeneral("");
    setRequiereEnvio(false);
    setMostrarBotonEnvio(false);
    setSelectedEvent({});
  };

  const eliminarDireccion = (index) => {
    setFormularioClientes((prevState) => {
      const nuevasDirecciones = [...prevState.direcciones];
      nuevasDirecciones.splice(index, 1);
      return { ...prevState, direcciones: nuevasDirecciones };
    });
  };

  const guardarPedido = async () => {
    if (carritoPedidos.length === 0) {
      mostraAlertaError("No hay productos en el carrito.", "Error");
      return;
    }

    if (!selectedEvent.clienteId) {
      mostraAlertaError(
        "Debes seleccionar un cliente antes de guardar el pedido.",
        "Error"
      );
      return;
    }

    if (!usuario?.datoPersonales?.id) {
      mostraAlertaError(
        "No se pudo identificar al empleado. Verifica tu sesión.",
        "Error"
      );
      return;
    }
    mostrarAlertaLoading("Guardando pedido...", "Esto puede tardar unos segundos");
    const direccionesVacia = formularioClientes.direcciones.filter(
      (f) => f.direccion !== "" || f.longitud !== null || f.latitud !== null
    );
    const detalles = carritoPedidos.map((item) => ({
      productoId: item.id,
      cantidad: item.cantidad > 0 ? item.cantidad : 1,
      precio: parseFloat(item.price) || 0,
      loteId: item.loteSeleccionado?.id || null,
      loteInventarioId: item.loteInventarioSeleccionado?.id || null,
    }));
    const payload = {
      fecha: moment().toISOString(),
      estado: "Programada",
      envio: direccionesVacia.length > 0 ? "Pendiente" : "Sin envío",
      notas: notaGeneral || "Sin notas",
      clienteId: selectedEvent.clienteId,
      rtn: selectedEvent.clienteRtn,
      empleadoId: usuario.datoPersonales.id,
      detalles,
      direcciones: direccionesVacia,
      estacionDatos: estacion, 
    };

    try {
      const response = await AxiosPublico.post(PedidosGuardar, payload);
      mostraAlertaOk("Pedido guardado correctamente.", "Éxito");

      const pedido = response.data;
      ActualizarProductos();

      mostraAlertaPersonalizada({
        titulo: "¿Deseas realizar la venta ahora?",
        mensaje: "El pedido se ha guardado correctamente. Puedes ir a la página de ventas o permanecer aquí para seguir con otros pedidos.",
        icono: "question",
        textoConfirmacion: "Sí, ir a realizar la venta",
        textoCancelacion: "No, permanecer aquí",
        accion: (confirmado) => {
          if (confirmado) {
            navigate('/app/admin/ventas/nuevo',
              {
                state: {
                  pedidoId: pedido.id,
                  clienteId: selectedEvent.clienteId,
                  clienteNombre: selectedEvent.clienteNombre,
                  clienteRtn: selectedEvent.clienteRtn,
                }
              }
            );
          }
        },
      });
      vaciarCarritoPedidos();
      limpiarDatos();
    } catch (error) {
      console.error("Error al guardar el pedido:", error);
      ErroresPeticion(error);
    }
  };

  const handleClienteSeleccionado = (cliente) => {
    setSelectedEvent((prev) => ({
      ...prev,
      clienteId: cliente.id,
      clienteNombre: cliente.nombreCompleto,
      clienteRtn: cliente.rtn,
      clienteImagen: ImagenCliente + cliente.imagen,
      clienteEmpresas: cliente.ClienteEmpresas,
      clienteTelefonos: cliente.ClienteTelefonos,
      clienteDireccions: cliente.ClienteDireccions
    }));
    setModalClienteOpen(false);
  };

  const seleccionarRtn = (rtn) => {
    setSelectedEvent((prev) => ({
      ...prev,
      clienteRtn: rtn,
    }));
  };

  useEffect(() => {
  }, [listaProductos]);

  const filteredClientes = clientes.filter((cliente) => {
    const searchTerm = clienteSearchTerm.trim().toLowerCase();

    // 1. Búsqueda por Nombre Completo del Cliente
    const nombreClienteMatch = cliente.nombreCompleto
      .toLowerCase()
      .includes(searchTerm);

    // 2. Búsqueda por Nombre de la Empresa del Cliente
    const nombreEmpresaMatch =
      cliente.ClienteEmpresas &&
      cliente.ClienteEmpresas.some((empresa) =>
        empresa.nombre.toLowerCase().includes(searchTerm)
      );

    // El cliente se incluye si coincide por nombre completo O por el nombre de alguna de sus empresas
    return nombreClienteMatch || nombreEmpresaMatch;
  });

  const [paginaCliente, setPaginaCliente] = useState(1);
  const clientesPorPagina = 5;
  const indexUltimoCliente = paginaCliente * clientesPorPagina;
  const indexPrimeroCliente = indexUltimoCliente - clientesPorPagina;
  const clientesPagina = filteredClientes.slice(indexPrimeroCliente, indexUltimoCliente);
  const totalPaginasCliente = Math.ceil(filteredClientes.length / clientesPorPagina);

  useEffect(() => {
  }, [modalIsOpen]);

  const totalPedido = useMemo(() => {
    return carritoPedidos.reduce((sum, item) => {
      return sum + (parseFloat(item.price) * item.cantidad);
    }, 0).toFixed(2);
  }, [carritoPedidos]);

  return (
    <Page datos={datos}>
      <Card
        pie={<>
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center w-100 gap-2 mb-3 mb-md-0">
            <button className="btn btn-success flex-grow-1 flex-md-grow-0" onClick={guardarPedido}>
              <i className="fas fa-save me-2 mx-2" /> Guardar
            </button>
            <h5 className="mb-2 mb-md-0 text-md-end text-center mt-3 mt-md-0">Total del Pedido:
              <span className="mx-2 fw-bold">{formatoMoneda(totalPedido)}
              </span>
            </h5>
          </div>
        </>}
      >
        <div className="mb-4">
          {selectedEvent.clienteNombre ? (
              <CardPerfilCliente
                nombre={selectedEvent.clienteNombre}
                rtn={selectedEvent.clienteRtn}
                avatarUrl={selectedEvent.clienteImagen}
                empresa={selectedEvent.clienteEmpresas}
                seleccionarRtn ={seleccionarRtn}
              />
          ) : (
            <h6 className="text-muted text-center text-md-start">
              No se ha seleccionado cliente
            </h6>
          )}
        </div>
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3">
          <div className="border rounded p-3 shadow-sm bg-light">
            <h6 className="text-muted mb-3">Acciones</h6>
            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
              <ModalProductosWizard
                modalIsOpen={modalIsOpen}
                setModalIsOpen={setModalIsOpen}
                listaProductos={listaProductos}
                agregarAlCarrito={agregarAlCarrito}
              />
              <ModalBootstrap
                titulo="Agregar Cliente"
                nombreBoton="Buscar Cliente"
                estiloBoton="btn btn-primary me-2 mb-2 mx-1"
                iconBoton="fa-solid fa-magnifying-glass"
                modalIsOpen={modalClienteOpen}
                setModalIsOpen={setModalClienteOpen}
              >
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar cliente..."
                    value={clienteSearchTerm}
                    onChange={(e) => setClienteSearchTerm(e.target.value)}
                  />
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered table-striped table-hover shadow-smr">
                    <thead className="bg-dark text-white">
                      <tr>
                        <th>ID</th>
                        <th>Empresas</th>
                        <th>Nombre Completo</th>
                        <th>Agregar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {clientesPagina.length > 0 ? (
                        clientesPagina.map((cliente) => (
                          <tr key={cliente.id}>
                            <td>{cliente.id}</td>
                            <td className="align-middle">
                              {cliente.ClienteEmpresas && cliente.ClienteEmpresas.length > 0
                                ? cliente.ClienteEmpresas.map((empresa, index) => (
                                  <div key={index} className="mb-1">
                                    {empresa.nombre}
                                  </div>
                                ))
                                : "N/A"}
                            </td>
                            <td>{cliente.nombreCompleto}</td>
                            <td className="text-center align-middle">
                              <button
                                className="btn btn-success btn-sm"
                                onClick={() =>
                                  handleClienteSeleccionado(cliente)
                                }
                              >
                                <i className="fa-regular fa-square-check" />
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center text-muted">
                            No se encontraron clientes
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="d-flex justify-content-center">
                    <nav className="mt-2">
                      <ul className="pagination pagination-sm justify-content-center shadow-sm bg-light p-3 rounded">
                        {/* Botón "Anterior" */}
                        <li className={`page-item ${paginaCliente === 1 ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => setPaginaCliente(paginaCliente - 1)}
                            aria-label="Anterior"
                          >
                            <i className="fas fa-chevron-left me-1"></i> Anterior
                          </button>
                        </li>

                        {
                          (() => {
                            const pagesToShow = 5;
                            const halfPages = Math.floor(pagesToShow / 2);
                            let startPage = Math.max(1, paginaCliente - halfPages);
                            let endPage = Math.min(totalPaginasCliente, paginaCliente + halfPages);

                            if (paginaCliente <= halfPages) {
                              endPage = Math.min(totalPaginasCliente, pagesToShow);
                            }
                            if (paginaCliente > totalPaginasCliente - halfPages) {
                              startPage = Math.max(1, totalPaginasCliente - pagesToShow + 1);
                            }

                            const pageButtons = [];
                            for (let i = startPage; i <= endPage; i++) {
                              pageButtons.push(
                                <li
                                  key={i}
                                  className={`page-item ${paginaCliente === i ? "active" : ""}`}
                                >
                                  <button className="page-link fw-bold" onClick={() => setPaginaCliente(i)}>
                                    {i}
                                  </button>
                                </li>
                              );
                            }
                            return pageButtons;
                          })()
                        }

                        {/* Botón "Siguiente" */}
                        <li className={`page-item ${paginaCliente === totalPaginasCliente ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => setPaginaCliente(paginaCliente + 1)}
                            aria-label="Siguiente"
                          >
                            Siguiente <i className="fas fa-chevron-right ms-1"></i>
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </ModalBootstrap>
              <Link to={"/app/admin/clientes/auto"} className="btn btn-primary mb-2 me-2 mx-1"> Nuevo Cliente
                <i className="fas fa-plus mx-2"></i>
              </Link>
            </div>
          </div>
        </div>
        <div className="mb-3">
          {carritoPedidos?.length > 0 ? (
            <div className="d-flex flex-column gap-3">
              {carritoPedidos.map((item, index) => {
                const uniqueKey = `${item.id}-${item.loteSeleccionado?.id || 'no-lote'}-${item.loteInventarioSeleccionado?.id || 'no-inv'}-${index}`;
                return (
                  <DetalleProductoPedido key={uniqueKey} item={item} index={index} listaProductos={listaProductos} setCarritoPedidos={setCarritoPedidos} />
                )
              })}
            </div>
          ) : (
            <h6 className="text-center">No tienes productos en tu carrito</h6>
          )}
        </div>
        <div className="form-check form-switch mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="switchEnvio"
            checked={requiereEnvio}
            onChange={(e) => {
              setRequiereEnvio(e.target.checked);
              setMostrarBotonEnvio(e.target.checked);
            }}
          />
          <label className="form-check-label" htmlFor="switchEnvio">
            ¿Este pedido requiere envío?
          </label>
        </div>

        {mostrarBotonEnvio && (
          <>
            <div className="row">
              <div className="col-12">
                <label className="fw-bold">
                  <i className="fas fa-truck text-primary me-2"></i>
                  <span className="mx-2">Cobro extra por envío</span>
                </label>
                <p className="text-muted small">
                  Al seleccionar envío, se añadirá un costo adicional para cubrir el transporte y la entrega del pedido.
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <label className="fw-bold">Direccion del envio</label>
                <div className="pb-3">
                  <GestionUbicacion
                    direccion={nuevaDireccion}
                    setDireccion={setNuevaDireccion}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    setSeleccionarDireccion={setSeleccionarDireccion}
                    textoBoton={"Agregar Ubicación"}
                    verdireccion={false}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  {formularioClientes.direcciones
                    .filter((f) => f.direccion && f.latitud && f.longitud)
                    .map((f, index) => (
                      <div key={index} className="row align-items-center mb-2">
                        <div className="col-9">
                          <p className="text-muted mb-0">{f.direccion}</p>
                        </div>
                        <div className="col-3 d-flex align-items-center gap-2">
                          <VerUbicacion direccion={f} />
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => eliminarDireccion(index)}
                            title="Eliminar dirección"
                          >
                            <i className="fa fa-minus" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </>
        )}
        <div className="mb-3">
          <label className="form-label fw-bold">
            <i className="fas fa-sticky-note me-1"></i> Nota del Pedido:
          </label>
          <textarea
            id="notaGeneral"
            className="form-control border-primary rounded shadow-sm"
            placeholder="Agrega una nota general..."
            value={notaGeneral}
            onChange={(e) => setNotaGeneral(e.target.value)}
          ></textarea>
        </div>
      </Card>
    </Page>
  );
};

export default HomePedidos;